<template>
  <Modal
    :title="$t('create_store')"
    modalId="create-modal"
    @submit="submitStore"
    @cancel="resetForm"
  >
    <form @submit.prevent="submitStore">
      <div class="mb-3">
        <label class="form-label">
          {{ $t('store_name') }} <span class="text-danger">*</span>
        </label>
        <input
          type="text"
          v-model="stores.name"
          class="form-control"
        />
        <div v-if="errors.name" class="text-danger mt-2">
          <span>{{ errors.name }}</span>
        </div>

        <label class="form-label">
          {{ $t('store_address') }}
        </label>
        <input
          type="text"
          v-model="stores.address"
          class="form-control"
        />
        <div v-if="errors.address" class="text-danger mt-2">
          <span>{{ errors.address }}</span>
        </div>

        <label class="form-label">
          {{ $t('store_phone_number') }}
        </label>
        <input
          type="text"
          v-model="stores.phone_number"
          class="form-control"
        />
        <div v-if="errors.phone_number" class="text-danger mt-2">
          <span>{{ errors.phone_number }}</span>
        </div>
      </div>
      <div v-if="errorMessage" class="text-danger mt-2">
        {{ errorMessage }}
      </div>
    </form>
  </Modal>
</template>

<script>
import Modal from "@/components/common/Modal.vue"; // Import Modal component
import apiUrls from "../../../urls";
import {useToast} from "vue-toastification";

export default {
   components: {
      Modal,
    },

   data() {
    return {
      stores: {
        name: '',
        address: '',
        phone_number: '',
      },
      errors: {},
      errorMessage: "",
    };
  },

  setup() {
    const toast = useToast()
    return {toast}
  },

  methods: {
      async submitStore() {
        this.errors = {};  // Reset errors
        this.errorMessage = "";  // Reset general error message

        // Frontend validation
        if (!this.stores.name.trim()) this.errors.name = this.$t('error.required');

        // **Phone number is optional but should be valid if entered**
        if (this.stores.phone_number.trim()) {
          const phoneRegex = /^[0-9]{10,15}$/;
          if (!phoneRegex.test(this.stores.phone_number.trim())) {
            this.errors.phone_number = this.$t('error.invalid_phone');
          }
        }

        if (Object.keys(this.errors).length > 0) return; // Stop if validation fails

        try {
          const formData = new FormData();
          Object.keys(this.stores).forEach((key) => {
            formData.append(key, this.stores[key]);
          });
          // Send API request
          const response = await this.$axios.post(apiUrls.inventory_store.post, formData, {
            headers: { "Content-Type": "multipart/form-data" },
          });

          this.toast.success('Store successfully created!')

          // Close modal after success
          const modal = document.getElementById("create-modal");
          const modalInstance = bootstrap.Modal.getInstance(modal);
          if (modalInstance) modalInstance.hide();

          // Emit event to update parent component
          this.$emit("create_success");

          this.resetForm();
        } catch (error) {
          if (error.response?.data?.error) {
            this.errorMessage = error.response.data.error;
          }

          // Handle field-specific errors dynamically
          if (error.response?.data?.errors) {
            this.errors = error.response.data.errors; // Dynamically set field errors
          }
        }
      },
      resetForm() {
      // Reset form fields and errors
      this.stores = { id: null, name: '', address: '', phone_number: '' };
      this.errors = {};
      this.errorMessage = "";
    }
  },
};
</script>
